import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-sms-modal-negoce',
    templateUrl: './sms-modal-negoce.component.html',
    styleUrls: ['./sms-modal-negoce.component.scss']
})
export class SmsModalNegoceComponent implements OnInit {
    @ViewChild('smsModal') smsModal!: TemplateRef<any>;
    private modalRef!: NgbModalRef;

    constructor(
        private toastr: ToastrService,
        private modalService: NgbModal
    ) {}

    ngOnInit(): void {}

    // Méthode pour ouvrir le modal depuis SmsModalNegoceComponent (optionnel)
    openModal(): void {
        const options: NgbModalOptions = {
            centered: true,
            backdrop: 'static',
            keyboard: true,
            size: 'lg',
            ariaLabelledBy: 'fileUploadModalLabel'
        };
        this.modalRef = this.modalService.open(this.smsModal, options);
    }

    // Méthode pour permettre à SharedComponent d'accéder au TemplateRef
    getModalTemplate(): TemplateRef<any> {
        return this.smsModal;
    }
}
